import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function isMultiSelectTaksReducer(state = initialState.isMultiSelectTasks, action) {
	switch (action.type) {
		case types.APPEND_MULTISELECT_TASK:
		case types.APPEND_MULTISELECT_TASKS:
		case types.REMOVE_MULTISELECT_TASK: {
			if (action.inputPayload && state !== action.inputPayload.isMultiselect) {
				return action.inputPayload.isMultiselect;
			}

			return state;
		}
		case types.RESET_TASK_ATTRIBUTES:
		case types.RESET_IS_MULTISELECT_TASK: {
			return false;
		}
		case types.SET_IS_MULTISELECT_TASK: {
			return action.payload;
		}
		default:
			return state;
	}
}
